import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";
import {
    getClientById,
    getClientContacts,
} from "../api/clientService";

const ViewClient: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [client, setClient] = useState<any>(null);
    const [contacts, setContacts] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) fetchClientData(Number(id));
    }, [id]);

    const fetchClientData = async (clientId: number) => {
        try {
            setLoading(true);

            // ✅ client object is directly in res.data
            const clientRes = await getClientById(clientId);
            setClient(clientRes.data);

            // contacts API is paginated
            const contactRes = await getClientContacts(clientId);
            setContacts(contactRes.data?.results || []);
        } catch (err) {
            console.error("Failed to load client", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    if (!client) {
        return <div className="text-center mt-5">Client not found</div>;
    }

    // const activeContacts = contacts.filter(
    //     c => c.is_master === true
    // );
    const activeContacts = contacts;


    return (
        <>
            <PageHeader
                title="View Client"
                breadcrumbs={[
                    { label: "Dashboard", path: "/dashboard" },
                    { label: "Masters" },
                    { label: "Client Master", path: "/masters/client" },
                    { label: "View Client" },
                ]}
            />

            <div className="container mt-4">
                <div className="card common-form-card p-4">

                    {/* CLIENT DETAILS */}
                    <Section title="Client Details">
                        <Info label="Client Name" value={client.name} />
                        {/* <Info label="Segment" value={client.client_segment_name} /> */}
                        <Info label="PAN" value={client.pan_no || "—"} />
                        <Info label="GST" value={client.gst_no || "—"} />
                    </Section>




                    <Section title="Contacts">
                        {activeContacts.map((c, index) => (
                            <div className="row g-1 pb-1" key={index} style={{borderBottom:"1px solid #ddd"}}>
                                <Info label="Name" value={c.name} />
                                <Info label="Mobile" value={c.mobile_no} />
                                <Info label="Email" value={c.email} />
                                <Info label="Designation" value={c.designation} />
                            </div>
                        ))}

                    </Section>


                    <Section title="Billing Address">
                        <Info label="Address Line 1" value={client.address_line_1 || "—"} />
                        <Info label="Address Line 2" value={client.address_line_2 || "—"} />
                        <Info label="City" value={client.city || "—"} />
                        <Info label="State" value={client.state || "—"} />
                        <Info label="Pincode" value={client.pincode || "—"} />
                    </Section>


                    {/* FOOTER */}
                    <div className="d-flex justify-content-end mt-4">
                        <button
                            className="btn btn-secondary"
                            onClick={() => navigate("/masters/client")}
                        >
                            Back
                        </button>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ViewClient;

/* ========= SMALL HELPERS ========= */

const Section = ({ title, children }: any) => (
    <div className="form-section mt-0">
        <div className="form-section-header bg-primary text-white mb-0">
            {title}
        </div>

        <div className="row g-3 p-3">
            {children}
        </div>
    </div>
);


const Info = ({ label, value }: { label: string; value: string }) => (
    <div className="col-md-3">
        <div className="text-muted small">{label}</div>
        <div className="fw-semibold">{value}</div>
    </div>
);
